// extracted by mini-css-extract-plugin
export default {"zoomModal":"BU-z","image":"CU-z","button":"DU-z","isOverlayShown":"EU-z"};